import Moment from 'moment';

export const groupWeatherForecast = (items, timezone) => {
    const daysData = [];
    const cityOffsetMinutes = Number(timezone) / 60 || 0;

    (items || []).slice().sort((first, second) => Number(first.dt) - Number(second.dt)).forEach(item => {
        const forecastTime = Moment.unix(item.dt).utcOffset(cityOffsetMinutes);
        const date = forecastTime.format('YYYY-MM-DD');
        const weatherItem = { ...item, forecastTime: forecastTime.format('HH:mm') };
        const existingDay = daysData.find(day => day.date === date);

        if (!existingDay) {
            daysData.push({
                id: forecastTime.format('D'),
                date,
                minTemp: item.main.temp,
                maxTemp: item.main.temp,
                climateConditions: item.weather[0].main,
                description: item.weather[0].description,
                weatherData: [weatherItem],
            });
            return;
        }

        existingDay.minTemp = Math.min(existingDay.minTemp, item.main.temp);
        existingDay.maxTemp = Math.max(existingDay.maxTemp, item.main.temp);
        existingDay.weatherData.push(weatherItem);
    });

    daysData.forEach(day => day.weatherData.sort((first, second) => Number(first.dt) - Number(second.dt)));
    return daysData.sort((first, second) => first.date.localeCompare(second.date));
};

export const formatWeatherTemperature = (value, isEnglish, unavailable, decimals = 1) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue) || numericValue === -99) return unavailable;
    const convertedValue = isEnglish ? (numericValue * 9 / 5) + 32 : numericValue;
    return convertedValue.toFixed(decimals);
};

export const getLastHourlySample = (samples, selectedDay, hour) => {
    const day = Moment(selectedDay).startOf('day');
    let latest = null;
    let latestTime = -Infinity;

    (samples || []).forEach(sample => {
        if (sample.air_temperature === null || sample.air_temperature === undefined) return;
        const timestamp = Moment.utc(sample.datetime).local();
        if (!timestamp.isSame(day, 'day') || timestamp.hour() !== hour) return;
        const value = timestamp.valueOf();
        if (value > latestTime) {
            latest = sample;
            latestTime = value;
        }
    });

    return latest;
};

export const hasRainIncrease = (sample, samples) => {
    if (!sample || !Array.isArray(samples)) return false;
    const current = Number(sample.rain);
    if (!Number.isFinite(current) || current < 0) return false;

    const sampleTime = Moment(sample.datetime).valueOf();
    let previous = null;
    let previousTime = -Infinity;
    samples.forEach(item => {
        if (item === sample) return;
        const itemTime = Moment(item.datetime).valueOf();
        if (itemTime < sampleTime && itemTime > previousTime) {
            previous = item;
            previousTime = itemTime;
        }
    });

    if (!previous) return false;
    const previousRain = Number(previous.rain);
    return Number.isFinite(previousRain) && current - previousRain >= .1;
};
